export default __webpack_public_path__ + "static/media/24H_Green.304c57f1.png";